function validateEditMyAccountInfoForm() {
    const formSignup = document.querySelector('.js-my-account-edit-info-form');
    const emailInput = document.querySelector(
        '.js-my-account-edit-email-field'
    );
    const emailError = document.querySelector('.js-my-account-edit-email-sign');

    let emailDefaultState = true;

    $(emailInput).on('blur', function () {
        if ($(this).val() != '' && emailDefaultState == true) {
            emailDefaultState = false;
            validateEmail(emailInput, emailError);
        }
    });

    $(formSignup).submit(function (e) {
        e.preventDefault();

        if (validateEmail(emailInput, emailError)) {
            $(this)
                .off('submit')
                .on('submit', function () {
                    return true;
                });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });

    emailInput.addEventListener('input', () => {
        if (!emailDefaultState) {
            validateEmail(emailInput, emailError);
        }
    });

    $(document, '.mdl-wrap').on(
        'click',
        '.js-btn-field-clear-edit-email',
        function () {
            setTimeout(() => {
                validateEmail(emailInput, emailError);
            }, 0);
        }
    );
}

runIfElementExist(
    validateEditMyAccountInfoForm,
    '.js-my-account-edit-info-form'
);
